/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrdineUpdateDTO
 */
export interface OrdineUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof OrdineUpdateDTO
     */
    idDipendenza?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrdineUpdateDTO
     */
    dataConsegna?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrdineUpdateDTO
     */
    note?: string | null;
}

/**
 * Check if a given object implements the OrdineUpdateDTO interface.
 */
export function instanceOfOrdineUpdateDTO(value: object): value is OrdineUpdateDTO {
    return true;
}

export function OrdineUpdateDTOFromJSON(json: any): OrdineUpdateDTO {
    return OrdineUpdateDTOFromJSONTyped(json, false);
}

export function OrdineUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdineUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idDipendenza': json['idDipendenza'] == null ? undefined : json['idDipendenza'],
        'dataConsegna': json['dataConsegna'] == null ? undefined : (new Date(json['dataConsegna'])),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

  export function OrdineUpdateDTOToJSON(json: any): OrdineUpdateDTO {
      return OrdineUpdateDTOToJSONTyped(json, false);
  }

  export function OrdineUpdateDTOToJSONTyped(value?: OrdineUpdateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idDipendenza': value['idDipendenza'],
        'dataConsegna': value['dataConsegna'] == null ? undefined : ((value['dataConsegna']).toISOString()),
        'note': value['note'],
    };
}

